module.exports = __webpack_public_path__ + "static/media/loadingLocation.2d3c24dd.svg";